/**
 * Production Job Queue
 *
 * List of jobs for the selected work center.
 * Each job card shows routing context and status.
 */

import ProductionJobCard from './ProductionJobCard';

export default function ProductionJobQueue({
  jobs,
  activeSessions,
  selectedJob,
  onSelectJob,
  formatElapsed,
  workCenter,
}) {
  // Sort jobs: active first, then by due date
  const sortedJobs = [...jobs].sort((a, b) => {
    const aActive = activeSessions[a.jobId]?.state === 'running';
    const bActive = activeSessions[b.jobId]?.state === 'running';

    if (aActive && !bActive) return -1;
    if (!aActive && bActive) return 1;

    // Then by due date
    const aDate = a.dueDate ? new Date(a.dueDate) : new Date('2099-12-31');
    const bDate = b.dueDate ? new Date(b.dueDate) : new Date('2099-12-31');
    return aDate - bDate;
  });

  return (
    <div className="p-4 space-y-3">
      {sortedJobs.map(job => (
        <ProductionJobCard
          key={job.jobId}
          job={job}
          session={activeSessions[job.jobId]}
          isSelected={selectedJob?.jobId === job.jobId}
          onSelect={() => onSelectJob(job)}
          formatElapsed={formatElapsed}
          workCenter={workCenter}
        />
      ))}
    </div>
  );
}
